/**
 * Dashboard Tour Configuration
 * Introduces users to the main dashboard features
 */

import { TourDefinition } from './tour.types';

export const dashboardTour: TourDefinition = {
  id: 'dashboard-tour',
  name: 'Dashboard Overview',
  page: '/dashboard',
  version: 7, // Added activity feed, charts sections, and improved descriptions
  nextTourId: 'agency-dashboard-tour', // Chain to agency dashboard tour
  steps: [
    {
      id: 'welcome',
      targetSelector: '[data-tour="dashboard-header"]',
      title: 'Welcome to Your Dashboard!',
      description:
        'This is your command center for tracking performance, managing leads, and staying on top of your sales activities. Use the time period selector on the right to filter metrics by all-time, last month, or last week.',
      placement: 'bottom',
    },
    {
      id: 'metrics',
      targetSelector: '[data-tour="metrics-cards"]',
      title: 'Performance Metrics',
      description:
        'These cards show your key performance indicators: Total Premium Sold, Active Leads, Policies Sold, and Appointments. They update in real-time as you work and show comparison trends.',
      placement: 'bottom',
    },
    {
      id: 'activity-feed',
      targetSelector: '[data-tour="activity-feed"]',
      title: 'Activity & Communication',
      description:
        'The left sidebar shows your leads overview and communication metrics including total calls, SMS messages, emails, and faxes. Track your outreach efforts at a glance.',
      placement: 'right',
    },
  ],
};
